/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Calendar: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M8 10H4V13H8V10Z' fill='currentColor' />
    <path d='M14 10H10V13H14V10Z' fill='currentColor' />
    <path d='M8 15H4V18H8V15Z' fill='currentColor' />
    <path d='M14 15H10V18H14V15Z' fill='currentColor' />
    <path d='M20 10H16V13H20V10Z' fill='currentColor' />
    <path
      d='M23 3H18V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0C16.7348 0 16.4804 0.105357 16.2929 0.292893C16.1054 0.48043 16 0.734784 16 1V3H8V1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0C6.73478 0 6.48043 0.105357 6.29289 0.292893C6.10536 0.48043 6 0.734784 6 1V3H1C0.734784 3 0.48043 3.10536 0.292893 3.29289C0.105357 3.48043 0 3.73478 0 4L0 22C0 22.2652 0.105357 22.5196 0.292893 22.7071C0.48043 22.8946 0.734784 23 1 23H23C23.2652 23 23.5196 22.8946 23.7071 22.7071C23.8946 22.5196 24 22.2652 24 22V4C24 3.73478 23.8946 3.48043 23.7071 3.29289C23.5196 3.10536 23.2652 3 23 3ZM22 21H2V7H22V21Z'
      fill='currentColor'
    />
  </React.Fragment>
)
